module.exports = __webpack_public_path__ + "static/media/5.8c0702f6.jpeg";